import type { MenuEntry } from '../types';

export const mainMenu: MenuEntry[] = [
  { to: '/admin',               labelKey: 'admin.menu.overview',      icon: 'dashboard' },
  { to: '/admin/users',         labelKey: 'admin.menu.users',         icon: 'people' },
  { to: '/admin/projects',      labelKey: 'admin.menu.projects',      icon: 'folderOpen' },
  { to: '/admin/subscriptions', labelKey: 'admin.menu.subscriptions', icon: 'cardMembership' },
];

export const dataMenu: MenuEntry[] = [
  { to: '/admin/messages',      labelKey: 'admin.menu.messages',      icon: 'email' },
  { to: '/admin/consultations', labelKey: 'admin.menu.consultations', icon: 'forum' },
  { to: '/admin/activity',      labelKey: 'admin.menu.activity',      icon: 'history' },
  { to: '/admin/upload-errors', labelKey: 'admin.menu.uploadErrors',  icon: 'reportProblem' },
  { to: '/admin/login-journal', labelKey: 'admin.menu.loginJournal',  icon: 'login' },
  { to: '/admin/user-sessions', labelKey: 'admin.menu.userSessions',  icon: 'devices' },
];

export const platformMenu: MenuEntry[] = [
  { to: '/admin/keys',      labelKey: 'admin.menu.myKeys',   icon: 'vpnKey' },
  { to: '/admin/api-keys',  labelKey: 'admin.menu.apiKeys',  icon: 'adminPanel', superuser: true },
  { to: '/admin/people',    labelKey: 'admin.menu.people',   icon: 'people', superuser: true },
  { to: '/admin/usage',     labelKey: 'admin.menu.usage',    icon: 'insights' },
];
